import React, { useEffect, useState } from "react";
import { IPlayerAttributesData } from "../../../types/IPlayerAttributesData";
import { HeaderContent } from "../../../styled-components/RolesPlayedUtilsStyles";
import Switch from "../../../ui/CustomSwitch";
import { getColorByValue } from "../../../utils/pitchWidgetUtils";
import GoldStar from "../../../assets/icons/GoldStar.png";
import LabelText from "../../../ui/LabelText";
import { usePlayerSearch } from "../../../contexts/SearchPlayersContext";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import SecondaryButton from "../../../ui/SecondaryButton";
import { debug } from "console";
import LabelNumber from "../../../styled-components/LabelNumber";
import { useClubSearch } from "../../../contexts/ClubSearchContext";
import PositiveArrow from "../../../assets/icons/PositiveArrow.png";
import NegativeArrow from "../../../assets/icons/NegativeArrow.png";
import CustomizedTooltips from "../../../ui/Tooltip";

interface IAttributesTable {
  attributesData?: IPlayerAttributesData | undefined;
  attributeCompareData?: IPlayerAttributesData | undefined;
  selectedPosition?: "theirposition" | "allpositions";
  setSelectedPosition?: React.Dispatch<React.SetStateAction<"theirposition" | "allpositions">>;
  playerId? : number;
  clubName?: string;
  ifForTeam?: boolean;
}

interface IAttributeSection {
  title: string;
  InfoLabel:string;
  attributes: {
    label: string;
    key: string;
    description : string;
  }[];
}

interface AttributeData {
  avgScore: number;
  star?: boolean;
  [key: string]: {
    score: number;
  } | number | boolean | undefined;
}

type SectionKey = "defence" | "buildUpPlay" | "finalThird";

export const attributeSections: IAttributeSection[] = [
  {
    title: "Defensive",
    InfoLabel : "Defensive hull",
    attributes: [
      { label: "Tackling", key: "tackling", description : "Each dot represents a tackling attempt." },
      { label: "Defensive headers", key: "defensiveHeaders", description : "Each dot represents an attempt at a headed clearance." },
      { label: "Ball recovery", key: "aggression", description : "Each dot represents a lose ball duel." }
    ]
  },
  {
    title: "Build up play",
    InfoLabel : "Heat signature",
    attributes: [
      { label: "Creativity", key: "creativity", description : "The heat is made from a player’s creative actions" },
      { label: "Passing accuracy", key: "passingAccuracy", description : "The heat is made from a player’s passing attempts. " },
      { label: "Dribbling", key: "dribbling", description : "The heat is made from a player’s attempts to move with the ball. " },
      { label: "Crossing", key: "crossing", description : "The heat is made from a player’s attempts to cross the ball." }
    ]
  },
  {
    title: "Final third",
    InfoLabel : "Event markers",
    attributes: [
      { label: "Finishing - Shots", key: "finishingShots", description : "Each dot represents a single shot attempt. Dot colour represents effectiveness:"},
      { label: "Finishing - Aerial", key: "finishingAerial", description : "Each dot represents a single headed goal attempt. Dot colour represents effectiveness:" },
      { label: "Attack positioning", key: "attackPositioning", description : "Each dot represents a ball reception. Dot colour represents effectiveness:" }
    ]
  }
];

const AttributeSection: React.FC<{
  section: IAttributeSection;
  attributesData: any | undefined;
  attributeCompareData?: any | undefined;
  comparisonArea: "universe" | "league";
  selectedPosition: "theirposition" | "allpositions";
  clubName?: string;
  isForTeam?: boolean;
}> = ({ section, attributesData,attributeCompareData, comparisonArea , selectedPosition ,clubName, isForTeam}) => {
  // const dataSource = comparisonArea === "universe" ? attributesData?.playerAttributesUniverseTheirPos : attributesData?.playerAttributesLeagueTheirPos;
  const {selectedAttr , setSelectedAttr , attrDescription , setAttributesDescription , attrInfoLabel , setAttrInfiLabel , attrIndex,setCurrentAttrIndex} = useSearch();
  const {clubCompareId , compareClubName} = useClubSearch();

    let dataSource;

    if (comparisonArea === "universe") {
      dataSource = selectedPosition === "theirposition"
        ? attributesData?.playerAttributesUniverseTheirPos
        : attributesData?.playerAttributesUniverseAllPos;
    } else {
      dataSource = selectedPosition === "theirposition"
        ? attributesData?.playerAttributesLeagueTheirPos
        : attributesData?.playerAttributesLeagueAllPos;
    }
    if(isForTeam){
      dataSource = attributesData
    }

    const sectionKeyMap: Record<string, SectionKey> = {
      "Final third": "finalThird",
      "Build up play": "buildUpPlay",
      "Defensive": "defence",
    };
    const sectionKey = sectionKeyMap[section.title];
    const sectionData = dataSource?.[sectionKey] as AttributeData | undefined | any;
    const compareData = attributeCompareData?.[sectionKey] as AttributeData | undefined | any;
    const getScoreStyle = (score: number) => ({
      backgroundColor: getColorByValue(score),
      color: score <= 39 ? 'white' : 'inherit'
    });
    const flattenedAttributes = attributeSections.flatMap(section =>
      section.attributes.map(attr => ({
        sectionTitle: section.title,
        attribute: attr
      }))
    );

    const handleAttributesSelection = (label : string , description : string) =>{
      setSelectedAttr(label)
      const foundIndex = flattenedAttributes.findIndex(
        item => item.attribute.label === label
      );
      if (foundIndex !== -1) {
        setCurrentAttrIndex(foundIndex);
      }
      setAttributesDescription(description)
      if(label === 'Finishing - Shots' || label === 'Finishing - Aerial' || label ===  'Attack positioning'){ setAttrInfiLabel('Event markers')}
      if(label === 'Creativity' || label === 'Passing accuracy' || label === 'Dribbling' || label === 'Crossing'){ setAttrInfiLabel('Heat signature')}
      if(label === 'Tackling' || label === 'Defensive headers' || label ===  'Ball recovery'){ setAttrInfiLabel('Defensive hull')}

    }

    const bgcoloroftag = (tital : string)=>{
      if(tital === "Defensive") return "#64ADDB"
      else if(tital === "Build up play") return "#C9F0B5"
      else return "#FFC2C2"
    }

    const differenceData = compareData && (sectionData?.avgScore - compareData?.avgScore)
    

    return (
      <>
      <div className="attribute-individual-table">
          <div className="first-container-attributes">
              <div className="attributes-section-tital">
                  {isForTeam && (<div className="archtype-tag" style={{background:bgcoloroftag(section.title) , width:'12px',height:'12px'}}></div>)}
                  <LabelText className="player-given-name">{section.title}</LabelText>
              </div>
              <div className="star-score-attribute-container">
                {compareData && (
                <CustomizedTooltips title={clubName + (differenceData > 0 ? " is higher by " : " is lower by ") + Math.abs(differenceData?.toFixed(2))  + " than " + compareClubName}>
                 <LabelNumber className={differenceData && differenceData > 0 ? "positive-difference" : "negative-difference"} style={{cursor:'pointer'}}>
                    {compareData && (<img height={18} width={14} src={differenceData && differenceData > 0 ? PositiveArrow : NegativeArrow} alt="negative" />)}
                    {compareData && Math.abs(differenceData?.toFixed(2))}
                  </LabelNumber>
                </CustomizedTooltips>
                )}
                  {sectionData?.star && <img src={GoldStar} alt="star" />}
                  <span style={getScoreStyle(sectionData?.avgScore || 0)}>
                    {sectionData?.avgScore === 100 ? '99.99' : sectionData?.avgScore?.toFixed(2)}
                  </span>
                  
              </div>
          </div>
          {section.attributes.map((attr) => {
            const attributesDifferenceData = compareData && (sectionData?.[attr.key] as { score: number })?.score - (compareData?.[attr.key] as { score: number })?.score ;
            return (
              <div key={attr.key} className="rest-invidual-attributes" style={{backgroundColor : !isForTeam ? (selectedAttr === attr.label ? '#00A1E4' :'transparent') : 'transparent'}}>
                  <div className="attributes-onpitch-label">
                      {!isForTeam && (
                        <input type="radio" id="html" className="custom-radio" name="fav_language" value="HTML" checked={selectedAttr === attr.label} onChange={()=>{handleAttributesSelection(attr.label,attr.description)}}
                      ></input>)}
                      <LabelText style={{color : !isForTeam ? (selectedAttr === attr.label ? 'white' :'') : ''}}>{attr.label}</LabelText>
                  </div>
                  <div className="star-score-attribute-container">
                      {sectionData?.star && <img src={GoldStar} alt="star" />}
                      {compareData && (
                      <CustomizedTooltips title={clubName + (attributesDifferenceData > 0 ? " is higher by " : " is lower by ") + Math.abs(attributesDifferenceData?.toFixed(2))  + " than " + compareClubName}>
                      <LabelNumber className={attributesDifferenceData && attributesDifferenceData > 0 ? "positive-difference" : "negative-difference"} style={{cursor:'pointer'}}>
                        {compareData && (<img height={18} width={14} src={attributesDifferenceData && attributesDifferenceData > 0 ? PositiveArrow : NegativeArrow} alt="negative" />)}
                        {compareData && Math.abs(attributesDifferenceData?.toFixed(2))}
                      </LabelNumber>
                      </CustomizedTooltips>
                      )}
                      <span style={getScoreStyle((sectionData?.[attr.key] as { score: number })?.score || 0)}>
                        {(sectionData?.[attr.key] as { score: number })?.score === 100 ? '99.99' : (sectionData?.[attr.key] as { score: number })?.score?.toFixed(2)}
                      </span>
                  </div>
              </div>
            );
          })}
      </div>
      </>
    );
};

export const AttributesTable: React.FC<IAttributesTable> = ({
  selectedPosition,
  attributesData,
  attributeCompareData,
  setSelectedPosition,
  playerId,
  clubName,
  ifForTeam
}) => {
  const {selectedAttr , setSelectedAttr , attrIndex,setCurrentAttrIndex} = useSearch();
  const [attributeComparisonArea, setAttributeComparisonArea] = useState<"universe" | "league">("league");

  const flattenedAttributes = attributeSections.flatMap(section =>
    section.attributes.map(attr => ({
      sectionTitle: section.title,
      attribute: attr
    }))
  );
  
  const selectedAttrIndex = flattenedAttributes.findIndex(
    item => item.attribute.label === selectedAttr
  );

  const handlePrevious = () => {
    setCurrentAttrIndex(prev =>
      (prev - 1 + flattenedAttributes.length) % flattenedAttributes.length
    );
  };
  
  const handleNext = () => {
    setCurrentAttrIndex(prev =>
      (prev + 1) % flattenedAttributes.length
    );
  };
  

  useEffect(() => {
    const { attribute } = flattenedAttributes[attrIndex];
    setSelectedAttr(attribute.label);
  }, [attrIndex]);

  useEffect(()=>{
    const foundIndex = flattenedAttributes.findIndex(
      item => item.attribute.label === selectedAttr
    );
    if (foundIndex !== -1) {
      setCurrentAttrIndex(foundIndex);
    }
  },[playerId,attributesData])
  
  return (
    <div className="common-page-css">
      {!ifForTeam &&(
      <HeaderContent className="common-header" style={{padding:'16px',marginBottom:'24px',border:'none'}}>
        <h3>{ifForTeam ? "" : selectedAttr}</h3>
            <div className='pre-next-container'>
              <SecondaryButton  iconType='arrowleft' onClick={handlePrevious} className="onpitch-pre-next"/>
              <SecondaryButton  iconType='arrowright' onClick={handleNext} className="onpitch-pre-next"/>
            </div>
      </HeaderContent>  
    )}
      <div className="attributes-tables-parent">
        {attributeSections.map((section) => (
          <AttributeSection
            key={section.title}
            section={section}
            attributesData={attributesData}
            attributeCompareData={attributeCompareData}
            comparisonArea={attributeComparisonArea}
            selectedPosition={selectedPosition!}
            clubName={clubName}
            isForTeam={ifForTeam}
          />
        ))}
      </div>
      {!ifForTeam && (
          <div className="position-league-switcher-parent">
            <div className="position-league-switcher-container">
              <p>SCORED IN RELATION TO:</p>
              <div className="position-league-switcher">
                <LabelNumber className={selectedPosition === "allpositions" ? 'valuegraph-toggle-text' : 'goal-assist-name'} >THEIR POSITION</LabelNumber>
                <Switch
                  id="attribute-position"
                  toggled={selectedPosition === "allpositions"}
                  onChange={() => setSelectedPosition?.(selectedPosition === "allpositions" ? "theirposition" : "allpositions")}
                  source="Filter"
                  type='attributes'
                />
                <LabelNumber className={selectedPosition === "theirposition" ? 'valuegraph-toggle-text' : 'goal-assist-name'}>ALL POSITIONS</LabelNumber>
              </div>
              
              <div className="position-league-switcher">
              <LabelNumber className={attributeComparisonArea === "universe" ? 'valuegraph-toggle-text' : 'goal-assist-name'}>THEIR LEAGUE</LabelNumber>
                <Switch
                  id="league-position"
                  toggled={attributeComparisonArea === "universe"}
                  onChange={() => setAttributeComparisonArea(attributeComparisonArea === "league" ? "universe" : "league")}
                  source="Filter"
                  type='attributes'
                />
                <LabelNumber className={attributeComparisonArea === "league" ? 'valuegraph-toggle-text' : 'goal-assist-name'}>THE UNIVERSE</LabelNumber>
              </div>
            </div>
          </div>
      )}
      
    </div>
  );
};
